var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"dashboard-card",attrs:{"elevation":"0"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"dashboard-card-background-color",attrs:{"src":_vm.dashboardIMG,"contain":""}})],1)],1),_c('v-card-text',{staticClass:"dashboard-card-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }